import { render, staticRenderFns } from "./ChipInput.vue?vue&type=template&id=790ccc88&scoped=true&"
import script from "./ChipInput.vue?vue&type=script&lang=js&"
export * from "./ChipInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../bankari hypo/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790ccc88",
  null
  
)

export default component.exports